<template>
	<div>
		<img style="width: 100%;" class="bannerImg" src="@/assets/complianceStudy/banner.png" />
		<div class="academe flex-row">
			<left></left>
			<right :list="list" :attentionList="attentionList"></right>
		</div>
	</div>
</template>
<script>
import Left from './components/left.vue';
import Right from './components/right.vue';
import { getLearningMaterialList,getRelaLearningMaterials } from '@/api/complianceStudy/complianceStudy.js';
export default {
	name: 'demo',
	components: { Left, Right },
	data() {
		return {
			currentPage: 1,
			activeValue: 0,
			screenheight: '800px',
			attentionList: [
				{
					iconUrl: '',
					titel: '药销通订阅号',
					QRCode: require('@/assets/footer/officialAccounts.png')
				},
				{
					iconUrl: '',
					titel: '药销通服务号',
					QRCode: require('@/assets/footer/fuwuhao.png')
				},
				{
					iconUrl: '',
					titel: '药代通医药资讯平台',
					QRCode: require('@/assets/complianceStudy/QRCode3.jpg')
				},
				{
					iconUrl: '',
					titel: '药销通视频号',
					QRCode: require('@/assets/complianceStudy/QRCode4.png')
				},
				{
					iconUrl: '',
					titel: '药销通抖音号',
					QRCode: require('@/assets/footer/douyin_company.png')
				},
				{
					iconUrl: '',
					titel: '药销通冯军合规课堂',
					QRCode: require('@/assets/footer/douyin.png')
				}
			],
			list: [
			]
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.imgCalc();
		});
		window.addEventListener('resize', this.imgCalc);
		this.getRelaLearningMaterials();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.imgCalc);
	},
	methods: {
		//相关推荐
		getRelaLearningMaterials(){
			getRelaLearningMaterials().then(({data:res})=>{
				this.list=res.data.items;
			})
		},

		imgCalc() {
			let bannerImg = document.getElementsByClassName('bannerImg')[0];
			//当前宽度
			let areaClientWidth = bannerImg.clientWidth;
			this.screenheight = areaClientWidth / 2.37 + 'px';
		},
		handleClick() {}
	}
};
</script>

<style lang="scss" scoped>
.academe {
	margin: 0 auto;
	margin-top: 59px;
	width: $global-content-width;
	justify-content: space-between;
}
</style>
